<template>
  <div>
    <app-cells><h1 class="title">Post payment</h1></app-cells>
    <form @submit.prevent="onCheckForm">
      <app-form-group label="Client group" required>
        <v-select
          v-model="client_group"
          :options="client_group_options"
          :clearable="false"
          @input="onSelectClientGroup"
          @search="onClientGroupSearch"
          label="name"
          :filterBy="() => true"
          placeholder="Select group"
          class="select"
          :class="{'select--error': $v.client_group.$error}"
        >
          <template #open-indicator>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
              <path d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z" fill="#606060"/>
            </svg>
          </template>
          <template #no-options="{ search, searching }">
            <div v-if="searching" class="select__noty">
              No results for your search <em>{{ search }}</em>. Please try again.
            </div>
            <div v-else class="select__noty">
              Start entering group name
            </div>
          </template>
          <template #option="option">
            <div class="select__item d-center">{{ option.name }}</div>
          </template>
          <template #selected-option="option">
            <div class="selected d-center">{{ option.name }}</div>
          </template>
        </v-select>
        <template #error>
          <div v-if="$v.client_group.$dirty && !$v.client_group.required">Required field</div>
        </template>
      </app-form-group>
      <app-form-group label="Clients" required v-if="client_options.length">
        <v-select
          v-model="clients"
          :options="client_options"
          :reduce="client => client.id"
          label="full_name"
          placeholder="Select client"
          class="select select--multiple"
          multiple
          :class="{'select--error': $v.clients.$error}"
        >
          <template #open-indicator>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
              <path d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z" fill="#606060"/>
            </svg>
          </template>
          <template #option="option">
            <div class="select__item d-center">{{ option.full_name }}</div>
          </template>
          <template #selected-option="option">
            <div class="selected d-center">{{ option.full_name }}</div>
          </template>
        </v-select>
        <template #error>
          <div v-if="$v.clients.$dirty && !$v.clients.required">Required field</div>
        </template>
      </app-form-group>
      <app-form-group label="Invoices" v-if="invoice_options.length">
        <v-select
          v-model="invoices"
          :options="invoice_options"
          :reduce="invoice => invoice.id"
          label="number"
          placeholder="Select invoice"
          class="select select--multiple"
          multiple
        >
          <template #open-indicator>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
              <path d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z" fill="#606060"/>
            </svg>
          </template>
          <template #option="option">
            <div class="select__item d-center">{{ option.number }}</div>
          </template>
          <template #selected-option="option">
            <div class="selected d-center">{{ option.number }}</div>
          </template>
        </v-select>
      </app-form-group>
      <h2 class="title title--flex title--mb20">
        <span>Gear</span>
        <button @click="onAdd('gears')" type="button">
          <img src="@/assets/img/add-big-button-icon.svg" alt="">
        </button>
      </h2>
      <div v-if="gears.length" class="info-cards info-cards--mb20">
        <div
          v-for="(item, index) of gears"
          :key="index"
          class="info-cards__card info-cards__card--white"
        >
          <button class="info-cards__remove" @click="onRemove('gears', index)" />
          <app-form-group label="Client" required>
            <v-select
              v-model="item.client"
              :reduce="client => client.id"
              :options="client_options"
              :filterable="true"
              :clearable="false"
              :searchable="true"
              label="full_name"
              placeholder="Select client"
              class="select"
              :class="{'select--error': $v.gears.$each[index].client.$error}"
            >
              <template #open-indicator>
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
                  <path d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z" fill="#606060"/>
                </svg>
              </template>
              <template #option="option">
                <div class="select__item d-center">{{ option.full_name }}</div>
              </template>
              <template #selected-option="option">
                <div class="selected d-center">{{ option.full_name }}</div>
              </template>
            </v-select>
            <template #error>
              <div v-if="$v.gears.$each[index].client.$dirty && !$v.gears.$each[index].client.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group label="Amount ($)" :label-for="`gear_amount${index}`" required>
            <app-fin-number
              v-model="item.amount"
              :error="$v.gears.$each[index].amount.$error"
              :id="`gear_amount${index}`"
              placeholder="0"
              :name="`gear_amount${index}`"
              inputmode="numeric"
            />
            <template #error>
              <div v-if="$v.gears.$each[index].amount.$dirty && !$v.gears.$each[index].amount.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group label="Checklist">
            <app-uploader
              v-model="item.attachment"
              :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
              formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
            />
          </app-form-group>
        </div>
      </div>
      <h2 class="title title--flex title--mb20">
        <span>Additional services</span>
        <button @click="onAdd('additional_services')" type="button">
          <img src="@/assets/img/add-big-button-icon.svg" alt="">
        </button>
      </h2>
      <div v-if="additional_services.length" class="info-cards info-cards--mb20">
        <div
          v-for="(item, index) of additional_services"
          :key="index"
          class="info-cards__card info-cards__card--white"
        >
          <button class="info-cards__remove" @click="onRemove('additional_services', index)" />
          <app-form-group label="Client" required>
            <v-select
              v-model="item.client"
              :reduce="client => client.id"
              :options="client_options"
              :clearable="false"
              label="full_name"
              placeholder="Select client"
              class="select"
              :class="{'select--error': $v.additional_services.$each[index].client.$error}"
            >
              <template #open-indicator>
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
                  <path d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z" fill="#606060"/>
                </svg>
              </template>
              <template #option="option">
                <div class="select__item d-center">{{ option.full_name }}</div>
              </template>
              <template #selected-option="option">
                <div class="selected d-center">{{ option.full_name }}</div>
              </template>
            </v-select>
            <template #error>
              <div v-if="$v.additional_services.$each[index].client.$dirty && !$v.additional_services.$each[index].client.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group label="Description" :label-for="`services_desc${index}`" required>
            <app-input
              v-model="item.description"
              :error="$v.additional_services.$each[index].description.$error"
              :id="`services_desc${index}`"
              placeholder="Description"
              :name="`services_desc${index}`"
            />
            <template #error>
              <div v-if="$v.additional_services.$each[index].description.$dirty && !$v.additional_services.$each[index].description.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group label="Amount ($)" :label-for="`services_amount${index}`" required>
            <app-fin-number
              v-model="item.amount"
              :error="$v.additional_services.$each[index].amount.$error"
              :id="`services_amount${index}`"
              placeholder="0"
              :name="`services_amount${index}`"
              inputmode="numeric"
            />
            <template #error>
              <div v-if="$v.additional_services.$each[index].amount.$dirty && !$v.additional_services.$each[index].amount.required">Required field</div>
            </template>
          </app-form-group>
        </div>
      </div>
      <h2 class="title title--flex title--mb20">
        <span>Cash payment</span>
        <button @click="onAdd('cash_payments')" type="button">
          <img src="@/assets/img/add-big-button-icon.svg" alt="">
        </button>
      </h2>
      <div v-if="cash_payments.length" class="info-cards info-cards--mb20">
        <div
          v-for="(item, index) of cash_payments"
          :key="index"
          class="info-cards__card info-cards__card--white"
        >
          <button class="info-cards__remove" @click="onRemove('cash_payments', index)" />
          <app-form-group label="Currency" required>
            <app-cells :indent="false">
              <app-radio
                v-for="radio of currency_options"
                :key="radio.label"
                v-model="item.currency"
                :value="radio.value"
                :name="`filterCurrency${index}`"
                :checked="item.currency === radio.value"
              >
                <template #label>{{ radio.label }}</template>
              </app-radio>
            </app-cells>
          </app-form-group>
          <app-form-group label="Amount" :label-for="`cash_payments${index}`" required>
            <app-fin-number
              v-model="item.amount"
              :error="$v.cash_payments.$each[index].amount.$error"
              :id="`cash_payments${index}`"
              placeholder="0"
              :name="`cash_payments${index}`"
              inputmode="numeric"
            />
            <template #error>
              <div v-if="$v.cash_payments.$each[index].amount.$dirty && !$v.cash_payments.$each[index].amount.required">Required field</div>
            </template>
          </app-form-group>
        </div>
      </div>
      <template v-if="cash_payments.length">
        <app-form-group label="Change" required>
          <app-cells :indent="false">
            <app-radio
              v-for="radio of change_options"
              :key="radio.label"
              v-model="change_type"
              :value="radio.value"
              name="filterChange"
              :checked="change_type === radio.value"
              @change.native="onChangeType"
            >
              <template #label>{{ radio.label }}</template>
            </app-radio>
          </app-cells>
        </app-form-group>
        <app-form-group label="Date" required v-if="change_type === 'pending'">
          <date-picker
            v-model="change.date"
            format="DD MMM YYYY"
            value-type="YYYY-MM-DD"
            placeholder="Date"
            class="datepicker"
            popup-class="datepicker__popup"
            title-format="DD MMM YYYY"
            :lang="lang"
            :class="{'datepicker--error': $v.change.date.$error}"
          />
          <template #error>
            <div v-if="$v.change.date.$dirty && !$v.change.date.required">Required field</div>
          </template>
        </app-form-group>
        <app-form-group label="Currency" required v-if="change_type && change_type !== 'not'">
          <app-cells :indent="false">
            <app-radio
              v-model="change.currency"
              v-for="radio of currency_options"
              :key="radio.label"
              :value="radio.value"
              name="filterCurrencyChange"
              :checked="change.currency === radio.value"
              @change.native="onChangeCurrencyForAccount"
            >
              <template #label>{{ radio.label }}</template>
            </app-radio>
          </app-cells>
        </app-form-group>
        <app-form-group label="Account" required v-if="change_type === 'provided'">
          <v-select
            v-model="change.account"
            :options="account_options"
            :reduce="account => account.id"
            :filterable="true"
            :clearable="false"
            :searchable="true"
            label="name"
            placeholder="Select account"
            class="select"
            :class="{'select--error': $v.change.account.$error}"
          >
            <template #open-indicator>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
                <path d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z" fill="#606060"/>
              </svg>
            </template>
            <template #option="option">
              <div class="select__item d-center">{{ option.name }}</div>
            </template>
            <template #selected-option="option">
              <div class="selected d-center">{{ option.name }}</div>
            </template>
          </v-select>
          <template #error>
            <div v-if="$v.change.account.$dirty && !$v.change.account.required">Required field</div>
          </template>
        </app-form-group>
        <app-form-group label="Amount" label-for="change_amount" required v-if="change_type && change_type !== 'not'">
          <app-fin-number
            v-model="change.amount"
            :error="$v.change.amount.$error"
            id="change_amount"
            placeholder="0"
            name="change_amount"
            inputmode="numeric"
          />
          <template #error>
            <div v-if="$v.change.amount.$dirty && !$v.change.amount.required">Required field</div>
          </template>
        </app-form-group>
      </template>
      <h2 class="title title--flex title--mb20">
        <span>Card payment</span>
        <button @click="onAdd('pos_transactions')" type="button">
          <img src="@/assets/img/add-big-button-icon.svg" alt="">
        </button>
      </h2>
      <div v-if="pos_transactions.length" class="info-cards info-cards--mb20">
        <div
          v-for="(item, index) of pos_transactions"
          :key="index"
          class="info-cards__card info-cards__card--white"
        >
          <button class="info-cards__remove" @click="onRemove('pos_transactions', index)" />
          <app-form-group label="Amount ($)" :label-for="`pos_transactions${index}`" required>
            <app-fin-number
              v-model="item.amount"
              :error="$v.pos_transactions.$each[index].amount.$error"
              :id="`pos_transactions${index}`"
              :name="`pos_transactions${index}`"
              placeholder="0"
              inputmode="decimal"
            />
            <template #error>
              <div v-if="$v.pos_transactions.$each[index].amount.$dirty && !$v.pos_transactions.$each[index].amount.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group label="Bank" required>
            <app-cells :indent="false">
              <app-radio
                v-for="radio of bank_options"
                :key="radio.id"
                v-model="item.bank"
                :value="radio.id"
                name="filterBank"
                :checked="item.bank === radio.id"
              >
                <template #label>{{ radio.short_name }}</template>
              </app-radio>
            </app-cells>
          </app-form-group>
          <app-form-group label="Channel" required>
            <app-cells :indent="false">
              <app-radio
                v-for="radio of channel_options"
                :key="radio.code"
                v-model="item.channel"
                :value="radio.code"
                name="filterCreditCard"
                :checked="item.channel === radio.code"
              >
                <template #label>{{ radio.name }}</template>
              </app-radio>
            </app-cells>
          </app-form-group>
          <app-form-group label="RRN" required :label-for="`pos_transactions_rrn${index}`">
            <app-input
              v-model="item.rrn"
              :error="$v.pos_transactions.$each[index].rrn.$error"
              :id="`pos_transactions_rrn${index}`"
              :name="`pos_transactions_rrn${index}`"
              placeholder="RRN"
              type="number"
              inputmode="numeric"
            />
            <template #error>
              <div v-if="$v.pos_transactions.$each[index].rrn.$dirty && !$v.pos_transactions.$each[index].rrn.required">Required field</div>
              <div v-if="$v.pos_transactions.$each[index].rrn.$dirty && !$v.pos_transactions.$each[index].rrn.maxLength">Length of RRN must be equal to 12</div>
              <div v-if="$v.pos_transactions.$each[index].rrn.$dirty && !$v.pos_transactions.$each[index].rrn.minLength">Length of RRN must be equal to 12</div>
            </template>
          </app-form-group>
          <app-form-group label="Machine slip" required>
            <app-uploader
              v-model="item.machine_slip"
              :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
              formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
            />
            <template #error>
              <div v-if="$v.pos_transactions.$each[index].machine_slip.$dirty && !$v.pos_transactions.$each[index].machine_slip.required">Required field</div>
            </template>
          </app-form-group>
        </div>
      </div>
      <h2 class="title title--flex title--mb20">
        <span>Other payment</span>
        <button @click="onAdd('other_payments')" type="button">
          <img src="@/assets/img/add-big-button-icon.svg" alt="">
        </button>
      </h2>
      <div v-if="other_payments.length" class="info-cards info-cards--mb20">
        <div
          v-for="(item, index) of other_payments"
          :key="index"
          class="info-cards__card info-cards__card--white"
        >
          <button class="info-cards__remove" @click="onRemove('other_payments', index)" />
          <app-form-group label="Currency" required>
            <app-cells :indent="false">
              <app-radio
                v-for="radio of currency_options"
                :key="radio.label"
                v-model="item.currency"
                :value="radio.value"
                :name="`filterCurrencyOther${index}`"
                :checked="item.currency === radio.value"
              >
                <template #label>{{ radio.label }}</template>
              </app-radio>
            </app-cells>
          </app-form-group>
          <app-form-group label="Amount" :label-for="`other_payments${index}`" required>
            <app-fin-number
              v-model="item.amount"
              :error="$v.other_payments.$each[index].amount.$error"
              :id="`other_payments${index}`"
              placeholder="0"
              :name="`other_payments${index}`"
              inputmode="numeric"
            />
            <template #error>
              <div v-if="$v.other_payments.$each[index].amount.$dirty && !$v.other_payments.$each[index].amount.required">Required field</div>
            </template>
          </app-form-group>
          <app-form-group label="Description" :label-for="`other_desc${index}`" required>
            <app-input
              v-model="item.description"
              :error="$v.other_payments.$each[index].description.$error"
              :id="`other_desc${index}`"
              placeholder="Description"
              :name="`other_desc${index}`"
            />
            <template #error>
              <div v-if="$v.other_payments.$each[index].description.$dirty && !$v.other_payments.$each[index].description.required">Required field</div>
            </template>
          </app-form-group>
        </div>
      </div>
      <app-form-group label="Additional notes" label-for="notes">
        <app-textarea
          v-model="additional_notes"
          rows="5"
          placeholder="Write a note"
          id="notes"
        />
      </app-form-group>
      <app-multi-uploader v-model="attachments" />
      <app-cells position="center"><app-button ref="submit" type="submit">Post</app-button></app-cells>
    </form>
    <modal
      name="success-modal"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow modal-br"
    >
      <div class="popup">
        <div class="popup__title">Payment successfully submitted</div>
        <div class="popup__subt">Payment ID: {{ payment_id }}</div>
        <div class="popup__subt">Write this number in the description on the envelope. Press "Done" when finished.</div>
        <app-cells position="center"><app-button @click.native="onHideModal">Done</app-button></app-cells>
      </div>
    </modal>
  </div>
</template>

<script>

import {
  getClientGroupsSearch,
  getClientSearch,
  getFinanceInvoices,
  postFinancePaymentsOnSite,
  getFinanceAccountsCharge,
  getBanks,
  getCardTypes
} from '@/http'
import { required, requiredIf, maxLength, minLength } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'

export default {
  name: 'FinancePaymentsCreate',
  data() {
    return {
      page_loaded: true,
      client_group: null,
      clients: null,
      invoices: null,
      receipt_copy: null,
      additional_notes: '',
      client_group_options: [],
      client_options: [],
      invoice_options: [],
      account_options: [],
      bank_options: [],
      channel_options: [],
      gears: [],
      additional_services: [],
      cash_payments: [],
      pos_transactions: [],
      other_payments: [],
      attachments: [],
      change: {
        account: null,
      },
      change_type: null,
      payment_id: null,
      currency_options: [
        { value: 'USD', label: 'USD ($)' },
        { value: 'TZS', label: 'TZS (TSh)' },
        { value: 'EUR', label: 'EUR (€)' },
        { value: 'GBP', label: 'GBP (£)' },
      ],
      change_options: [
        { value: 'not', label: 'Not required' },
        { value: 'provided', label: 'Provided' },
        { value: 'pending', label: 'Pending' },
      ],
      lang: {
        formatLocale: {
          months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          firstDayOfWeek: 1,
        },
      },
    }
  },
  validations: {
    client_group: { required },
    clients: { required },
    change_type: {
      required: requiredIf(function() {
        return this.cash_payments.length
      }),
    },
    change: {
      date: {
        required: requiredIf(function() {
          return this.change_type === 'pending'
        }),
      },
      currency: {
        required: requiredIf(function() {
          return this.change_type && this.change_type !== 'not'
        }),
      },
      amount: {
        required: requiredIf(function() {
          return this.change_type && this.change_type !== 'not'
        }),
      },
      account: {
        required: requiredIf(function() {
          return this.change_type === 'provided'
        }),
      },
    },
    gears: {
      $each: {
        client: { required },
        amount: { required },
      }
    },
    additional_services: {
      $each: {
        client: { required },
        description: { required },
        amount: { required },
      }
    },
    cash_payments: {
      $each: {
        currency: { required },
        amount: { required },
      }
    },
    pos_transactions: {
      $each: {
        amount: { required },
        rrn: {
          required,
          maxLength: maxLength(12),
          minLength: minLength(12),
        },
        machine_slip: { required },
        bank: { required },
        channel: { required },
      }
    },
    other_payments: {
      $each: {
        currency: { required },
        amount: { required },
        description: { required },
      }
    }
  },
  created() {
    getBanks({pos: true}).then(response => { this.bank_options = response.data })
    getCardTypes().then(response => { this.channel_options = response.data })
  },
  methods: {
    onCheckForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      const data = {
        clients: this.clients,
        invoices: this.invoices,
        gears: this.gears.map(item => {
          const gearObj = {
            ...item
          }
          if (item.attachment) gearObj.attachment = item.attachment.id
          return gearObj
        }),
        additional_services: this.additional_services,
        cash_payments: this.cash_payments,
        pos_transactions: this.pos_transactions.map(item => ({ ...item, machine_slip: item.machine_slip.id })),
        additional_notes: this.additional_notes,
        attachments: this.attachments.map(({id}) => id),
        other_payments: this.other_payments,
      }
      for (const key in data) {
        if (!data[key] || !data[key].length) delete data[key]
      }
      data.change = this.change
      data.client_group = this.client_group.id
      if (!this.change_type || this.change_type === 'not') delete data.change
      postFinancePaymentsOnSite(data)
        .then(response => {
          this.payment_id = response.data.id
          this.$refs.submit.preload = false
          this.$modal.show('success-modal')
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    onAdd(field) {
      this[field].push({})
    },
    onRemove(field, index) {
      this[field].splice(index, 1)
    },
    onChangeType() {
      if (this.change_type === 'provided' && this.change.currency) {
        getFinanceAccountsCharge({ currency: this.change.currency }).then(response => { this.account_options = response.data })
      }
    },
    onChangeCurrencyForAccount(e) {
      if (this.change_type === 'provided') {
        this.change.account = null
        getFinanceAccountsCharge({ currency: e.target.value }).then(response => { this.account_options = response.data })
      }
    },
    onHideModal() {
      this.$router.push({ name: 'finance-payments' })
    },
    onSelectClientGroup(e) {
      this.clients = null
      this.invoices = null
      getClientSearch({ group: e.id }).then(response => { this.client_options = response.data })
      getFinanceInvoices({ client_group: e.id, charge_type: 'spot', status: 'sent' })
        .then(response => { this.invoice_options = response.data })
    },
    onClientGroupSearch(search, loading) {
      loading(true)
      this.searchClientGroup(loading, search, this)
    },
    searchClientGroup: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.client_group_options = []
      } else {
        getClientGroupsSearch({search}).then(response => {
          vm.client_group_options = response.data
          loading(false)
        })
      }
    }, 350),
  }
}
</script>
